import React from "react";
import { Helmet } from "react-helmet";
import SEOPage from "../Components/SEOPage";
import Navbar from "../Components/Navbar";
import ScrollReveal from "../Components/ScrollReveal";
import SiteFooter from "../Components/SiteFooter";
import Chatbox from "../Components/Chatbox";
import EcomHero from "../Components/ecommerce/EcomHero";
import WhyChooseEcom from "../Components/ecommerce/WhyChooseEcom";
import EcomFeatures from "../Components/ecommerce/EcomFeatures";
import EcomProcessTech from "../Components/ecommerce/EcomProcessTech";
import EcomProjects from "../Components/ecommerce/EcomProjects";
import EcomCta from "../Components/ecommerce/EcomCta";
import ecommerceFaqs from "../Components/ecommerce/ecommerceFaqs";
import FaqContact from "../Components/home/FaqContact";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: ecommerceFaqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

// Redesigned (Tailwind) page for /service/ecommerce-website-design-development-solutions.
const EcommerceWebsitePage = () => (
  <div>
    <SEOPage
      title="E-commerce Website Design & Development Company in Noida | DataMetricks"
      description="DataMetricks builds powerful, scalable and conversion-focused e-commerce websites on Shopify, WooCommerce, Magento and custom stacks, with secure payments, mobile-friendly design and SEO."
      canonicalUrl="https://www.datametricks.com/service/ecommerce-website-design-development-solutions"
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>

    <Navbar />
    <ScrollReveal />

    {/* Every Tailwind utility is scoped to `.tw` (see tailwind.config.js) */}
    <main className="tw">
      <EcomHero />
      <WhyChooseEcom />
      <EcomFeatures />
      <EcomProcessTech />
      <EcomProjects />
      <EcomCta />
      <FaqContact faqs={ecommerceFaqs} />
    </main>

    <Chatbox />
    <SiteFooter />
  </div>
);

export default EcommerceWebsitePage;
